export default "__VITE_ASSET__LUXg3GI2__"